export const breakpoints = {
	mobile: "300px",
	landscape: "600px",
	tablet: "800px",
	laptop: "1200px",
	desktop: "1440px",
	wide: "2250px",
};

export const getBreakpoints = () => breakpoints;

export default getBreakpoints;
